import React from 'react';
import PropTypes from 'prop-types';
import every from 'lodash.every';

import Page from 'components/Page';
import Button, {ModalXButton} from 'components/Button';
import Footer from 'components/Footer';
import Spinner from 'components/Spinner';

import handleInputChange from 'utils/handleInputChange';

import './style.css';

/* eslint-disable max-len */
export class SendInvite extends React.Component {
  constructor() {
    super();

    this.state = {
      message: '',
      to: '',
    };

    // handlers
    this.handleInputChange = handleInputChange.bind(this);
    this.handlePageSubmit = this.handlePageSubmit.bind(this);
  }
  handlePageSubmit() {
    const {message, email} = this.state;

    // dispatch submit
    if (this.canSubmit()) {
      this.props.submit({
        message,
        email,
      });
    }
  }
  canSubmit() {
    const email = this.state.email && this.state.email.split(',');

    // Check each email entered is valid
    let validEmails = false;
    const re = /\S+@\S+\.\S+/;

    validEmails = re.test(email);

    return !!this.state.message && validEmails;
  }
  render() {
    if (this.props.sending) {
      return (
        <Page>
          <Spinner />
        </Page>
      );
    }

    return (
      <Page>
        <header styleName="header toplevel">
          <h2 styleName="h2">Invite Investors</h2>
          <ModalXButton onClick={() => { this.props.cancel(); }} data-test="invite_cancel" />
        </header>
        <form styleName="form toplevel">
          <label htmlFor="email" styleName="email_label">Email:</label>
          <input type="text" id="email" name="email" onChange={this.handleInputChange} data-test="invite_email" styleName="email_input" placeholder="e.g. sandra@gmail.com" />
          <textarea id="message" name="message" rows="8" style={{width: '100%'}} onChange={this.handleInputChange} data-test="invite_message" placeholder="Enter your message here" />
        </form>
        <Footer styleName="toplevel">
          <Button onClick={this.handlePageSubmit} disabled={!this.canSubmit()} data-test="invite_submit">
            Invite
          </Button>
        </Footer>
      </Page>
    );
  }
}
/* eslint-enable max-len */

SendInvite.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default SendInvite;



// WEBPACK FOOTER //
// ./web/flows/deal/invite/component.js